import React, { useEffect, useState } from "react";
import styles from "../../../assets/css/admin/layout.module.css";
import "../../../assets/css/admin/allAdmins.module.css";
import SideBar from "../SideBar";
import axios from "axios";
import { baseUrl } from "../../../baseUrl";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { useAuth } from "../../../AuthContext";
import { useSidebar } from "../../../context/SidebarContext";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import api from "../../../api";
import {toast} from "react-toastify"

const AllStudents = () => {
  const { logout, user } = useAuth();
  const { isSidebarOpen, toggleSidebar } = useSidebar();

  const [students, setStudents] = useState([]);
  const [classFilter, setClassFilter] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalStudents, setTotalStudents] = useState(0);

  const getStudents = () => {
    api
      .get(
        `${baseUrl}/student/all?page=${page}&limit=${limit}&classFilter=${encodeURIComponent(
          classFilter
        )}`
      )
      .then((res) => {
        setStudents(res.data.students);
        setTotalPages(res.data.totalPages);
        setTotalStudents(res.data.total);
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    getStudents();
  }, [page, limit, classFilter]);

  const deleteStudent = (a) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        api.post(`${baseUrl}/student/delete/?id=${a._id}`).then(() => {
          getStudents();
          swal("Student has been deleted!", {
            icon: "success",
          });
        })
          .catch(err => {
            toast.error(err?.response?.data.message || "something went wrong")
          })
      }
    })
  };

  // Helper: Generate page numbers like 1 2 3 ... 20
  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    const startPage = Math.max(1, page - 2);
    const endPage = Math.min(totalPages, startPage + maxVisible - 1);

    if (startPage > 1) pages.push(1, "...");
    for (let i = startPage; i <= endPage; i++) pages.push(i);
    if (endPage < totalPages) pages.push("...", totalPages);

    return pages;
  };

  return (
    <div
      className={`${styles.layout} ${
        isSidebarOpen ? "" : `${styles.sidebarClosed}`
      }`}
    >
      <aside
        className={`${styles.sidebar} ${
          isSidebarOpen ? `${styles.open}` : `${styles.closed}`
        }`}
      >
        <SideBar />
      </aside>

      <main className={styles.mainContent}>
        <div style={{ height: "30px" }} className="position-relative">
          {isSidebarOpen ? (
            <CloseIcon
              className={`position-absolute end-0 ${styles.ham}`}
              onClick={toggleSidebar}
            />
          ) : (
            <MenuIcon
              className={`position-absolute end-0 ${styles.ham}`}
              onClick={toggleSidebar}
            />
          )}
        </div>

        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <div className="d-flex flex-grow-1">
              <li className="breadcrumb-item">
                <Link to="/admin/dashboard" className="text-decoration-none">
                  Dashboard
                </Link>
              </li>
              <li className="breadcrumb-item active">Students</li>
              <li className="breadcrumb-item">
                <Link
                  to="/admin/student/register"
                  className="text-decoration-none"
                >
                  Add
                </Link>
              </li>
              <li className="breadcrumb-item">
                <Link
                  to="/admin/students/view-details"
                  className="text-decoration-none"
                >
                  View
                </Link>
              </li>
            </div>
            <li className="nav-item dropdown">
              <span
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                href=""
                role="button"
                aria-expanded="false"
              >
                Welcome, {user.name}
                <i className="ml-2 fa fa-angle-down"></i>
              </span>
              <ul className="dropdown-menu" style={{ minWidth: "150px" }}>
                <li>
                  <span className="dropdown-item" onClick={logout}>
                    Logout
                  </span>
                </li>
              </ul>
            </li>
          </ol>
        </nav>

        <div
          className="container"
          style={{ backgroundColor: "white", padding: "40px" }}
        >
          <h4 className="mb-4">Students</h4>

          <div className="filters mb-4 d-flex flex-wrap gap-3 align-items-end">
            <div className="filter-item">
              <label htmlFor="classFilter" className="form-label">
                Filter by Class
              </label>
              <select
                id="classFilter"
                className="form-select"
                value={classFilter}
                onChange={(e) => {
                  setClassFilter(e.target.value);
                  setPage(1);
                }}
              >
                <option value="">All</option>
                <option value="Class XI">Class XI</option>
                <option value="Class XII">Class XII</option>
                <option value="Class XII Passed">Class XII Passed</option>
              </select>
            </div>

            <div className="filter-item">
              <label htmlFor="entries" className="form-label">
                Entries per page
              </label>
              <select
                id="entries"
                className="form-select"
                value={limit}
                onChange={(e) => {
                  setLimit(Number(e.target.value));
                  setPage(1);
                }}
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </div>

          <div style={{ overflowX: "scroll" }}>
            <table>
              <thead>
                <tr>
                  <td>SI</td>
                  <td>Name</td>
                  <td>Email</td>
                  <td>Registration Number</td>
                  <td>Action</td>
                </tr>
              </thead>
              <tbody>
                {students.length > 0 &&
                  students.map((a, i) => (
                    <tr key={i}>
                      <td>{(page - 1) * limit + i + 1}</td>
                      <td>{a.name}</td>
                      <td>{a.email}</td>
                      <td>{a.studentID}</td>
                      <td>
                        <Link to={`/student/edit/${a._id}`}>
                          <button className="btn btn-success btn-sm p-1">
                            Edit
                          </button>
                        </Link>
                        &nbsp;
                        <button
                          onClick={() => deleteStudent(a)}
                          className="btn btn-danger btn-sm p-1"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          <div className="d-flex justify-content-between align-items-center mt-3">
            <button
              className="btn btn-outline-primary btn-sm"
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            >
              Prev
            </button>

            <div className="d-flex gap-2">
              {getPageNumbers().map((p, i) =>
                p === "..." ? (
                  <span key={i}>...</span>
                ) : (
                  <button
                    key={i}
                    className={`btn btn-sm ${
                      p === page ? "btn-primary" : "btn-outline-primary"
                    }`}
                    onClick={() => setPage(p)}
                  >
                    {p}
                  </button>
                )
              )}
            </div>

            <button
              className="btn btn-outline-primary btn-sm"
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
            >
              Next
            </button>
          </div>

          <div className="text-end mt-2">
            Showing {(page - 1) * limit + 1}–
            {Math.min(page * limit, totalStudents)} of {totalStudents} entries
          </div>
        </div>
      </main>
    </div>
  );
};

export default AllStudents;